let shippingCountry = document.getElementById('AddressCountry_Shipping'),
    countryState = document.getElementById('AddressProvince_shipping'),
    shippingCountryZip = document.getElementById('ShippingAddressZip'),
    shippingRatePackage = document.querySelector('.shipping_rate_package'),
    shippingAddressWrapper = document.querySelector('.shipping_rate_message'),
    shippingAddressCount = document.querySelector('.shipping_address_count'),
    item = document.querySelector('.shipping_calc_save'),
    countrySelectsShipping = document.querySelectorAll('data-address-country-select');

if (Shopify && Shopify.CountryProvinceSelector) {
  new Shopify.CountryProvinceSelector('AddressCountry_Shipping', 'AddressProvince_shipping', {
    hideElement: 'AddressProvinceContainerNewShiping'
  });
}

const defaultShippingCountryOption = Array.from(shippingCountry.options).find((option) => {
  return option.textContent.trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '') === 'mexico';
});
if (defaultShippingCountryOption) {
  shippingCountry.value = defaultShippingCountryOption.value;
  shippingCountry.dispatchEvent(new Event('change'));
}

item.addEventListener('click', () => {
shippingRatePackage.innerHTML = '';
 if(shippingCountry.value !== "---"){
  item.classList.add('loading');  
  fetch(`/cart/shipping_rates.json?shipping_address%5Bzip%5D=${shippingCountryZip.value}&shipping_address%5Bcountry%5D=${shippingCountry.value}&shipping_address%5Bprovince%5D=${countryState.value}`)
  .then((response) => {
    if (response.ok) {
      return response.json()
    } else {
      throw `${window.shipping.wrong_message}`;
    }
  })
  .then((response) => {
    item.classList.remove('loading'); 

    shippingAddressWrapper.classList.remove('no-js-inline');
    if (shippingAddressCount) {
      shippingAddressCount.innerText = `${response.shipping_rates.length}`
    }
    response.shipping_rates.map((item) => {
      let row = document.createElement("DIV");
      row.setAttribute("class", 'shipping_rate_row');

      let name = document.createElement("SPAN");
      name.setAttribute("class", 'shipping_rate_row__name');
      name.innerText = item.name;

      let price = document.createElement("SPAN");
      price.setAttribute("class", 'shipping_rate_row__price');
      price.innerText = `${shopCurrencySymbol}${item.price}`;

      row.appendChild(name);
      row.appendChild(price);
      shippingRatePackage.appendChild(row);
    })
  })
  .catch((e) => {
    item.classList.remove('loading');     
    shippingAddressWrapper.classList.add('no-js-inline');
    shippingRatePackage.innerHTML = `<p class="error mt-15">${e}</p>`;
  });
}else{
  shippingAddressWrapper.classList.add('no-js-inline');
  shippingRatePackage.innerHTML = `<p class="error mt-15">${window.shipping.country_label}</p>`;
}
});